import { useRef, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  MarkupConfig,
  type MarkupConfigHandle,
} from "@/screens/pricing/platform-fee-config";

export function CarrierFeeSection({
  carrierId,
  carrierName,
}: {
  carrierId: string;
  carrierName: string;
}) {
  const editor = useRef<MarkupConfigHandle>(null);
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [saveError, setSaveError] = useState(false);
  async function save() {
    setSaveError(false);
    try {
      await editor.current?.save(() => toast.success("Carrier fee saved."));
    } catch {
      setSaveError(true);
    }
  }
  return (
    <section aria-label="Carrier fee" className="space-y-3">
      <p className="text-sm text-muted-foreground">
        Set the carrier-wide fee before adding the first service. Save this
        section separately from carrier details.
      </p>
      <fieldset disabled={busy}>
        <MarkupConfig
          ref={editor}
          carrierId={carrierId}
          carrierName={carrierName}
          onDirtyChange={setDirty}
          onSavingChange={setBusy}
          onLoadErrorChange={setLoadError}
        />
      </fieldset>
      {loadError && (
        <p role="alert">
          Unable to load the carrier fee. Close and reopen configuration to
          retry.
        </p>
      )}
      {saveError && (
        <p role="alert">
          Unable to save the carrier fee. Check the values and try again.
        </p>
      )}
      <Button
        type="button"
        disabled={busy || !dirty}
        onClick={() => void save()}
      >
        Save carrier fee
      </Button>
    </section>
  );
}
